import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ForsorjningskallaAggregat } from "~app/common/models/forsorjningskalla";
import { CommandService } from "~app/common/services/cqs/command.service";
import { RemoveForsorjningskallaCommandFactory } from "../../../common/remove-forsorjningskalla";
import { KundorderradAggregat } from "../kor-hot/kor-hot.model";

@Component({
    selector: "rask-kor-forsorjningsrad-edit",
    templateUrl: "./kor-forsorjningsrad-edit.component.html",
    styleUrls: ["./kor-forsorjningsrad-edit.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ButtonComponent]
})
export class KorForsorjningsradEditComponent {
    forsorjningskalla: ForsorjningskallaAggregat;
    kundorderrad: KundorderradAggregat;
    modal = inject(NgbActiveModal);

    private readonly commandService = inject(CommandService);

    dismiss(): void {
        this.modal.dismiss();
    }

    remove(): void {
        const command = RemoveForsorjningskallaCommandFactory.create(this.forsorjningskalla, this.kundorderrad.kundorderradId);
        this.commandService.addTransactionCommand(command);
        this.kundorderrad.removeForsorjningskalla(this.forsorjningskalla);
        this.modal.close(true);
    }
}
